export default __webpack_public_path__ + "static/media/metamask.576281bf.svg";